<div class="container-fluid py-4 main-container fade-in">
  <div class="dashboard-card shadow-sm mb-4 p-4 border-primary bg-white">
    <!-- Question-Level Filters Section -->
    <div class="mb-4">
      <h6 class="text-primary-purple font-weight-bold mb-3 d-flex align-items-center">
        <mat-icon class="mr-2">filter_list</mat-icon>
        {{ 'generic.filters' | translate }}
      </h6>

      <div class="row g-3">
        <!-- Search Bar -->
        <div class="col-md-6 col-lg-3">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>{{ 'generic.buttons.search' | translate }}</mat-label>
            <mat-icon matPrefix class="mr-2 text-muted" style="vertical-align: middle;">search</mat-icon>
            <input matInput type="text" [ngModel]="filters.search" (ngModelChange)="onSearchChange($event)" placeholder="{{ 'generic.search-for' | translate }}...">
            @if (filters.search) {
              <button mat-icon-button matSuffix (click)="clearSearch()" type="button">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>

        <!-- Question Typology Dropdown -->
        <div class="col-md-6 col-lg-3">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>{{ 'generic.typology' | translate }}</mat-label>
            <mat-select [(ngModel)]="filters.typologies" (selectionChange)="onTypologyChange()" multiple placeholder="{{ 'generic.all' | translate }}">
              <mat-select-trigger>
                {{ getSelectedTypologiesLabel() }}
              </mat-select-trigger>
              @for (option of typologyOptions; track option.value) {
                <mat-option [value]="option.value">
                  {{ option.label | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Required/Optional Dropdown -->
        <div class="col-md-6 col-lg-3">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>{{ 'generic.answers.mandatory' | translate }} / {{ 'generic.answers.just-suggestion' | translate }}</mat-label>
            <mat-select [(ngModel)]="filters.required" (selectionChange)="onRequiredChange()">
              <mat-option value="">{{ 'generic.all' | translate }}</mat-option>
              <mat-option value="true">{{ 'generic.answers.mandatory' | translate }}</mat-option>
              <mat-option value="false">{{ 'generic.answers.just-suggestion' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Decision Status Dropdown -->
        <div class="col-md-6 col-lg-3">
          <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
            <mat-label>{{ 'generic.evaluation' | translate }}</mat-label>
            <mat-select [(ngModel)]="filters.final_decision" (selectionChange)="onDecisionChange()">
              <mat-option value="">{{ 'generic.all' | translate }}</mat-option>
              @for (option of decisionOptions; track option.value) {
                <mat-option [value]="option.value">
                  {{ option.label | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Divider & Participant Filters -->
    @if (survey?.team_member_custom_fields && survey.team_member_custom_fields.length > 0) {
      <h6 class="text-primary-purple font-weight-bold mb-3 mt-4 border-top pt-3 d-flex align-items-center">
        <mat-icon class="mr-2">people</mat-icon>
        {{ 'generic.filters' | translate }} {{ 'generic.users' | translate | lowercase }}
      </h6>
      <app-survey-custom-fields-filter
        [teamMemberCustomFields]="survey?.team_member_custom_fields ?? []"
        [members]="survey?.members"
        [filters]="filters"
        (filterChange)="onFilterChange()">
      </app-survey-custom-fields-filter>
      @if (hasActiveCustomFilters()) {
              <div class="d-flex flex-wrap align-items-center mt-3">
                <button mat-stroked-button color="primary" type="button" class="mr-2" [disabled]="subsetDegrees.loading" (click)="computeFilterDegrees()">
                  @if (subsetDegrees.loading) {
                    <mat-spinner diameter="16" class="d-inline-block mr-2"></mat-spinner>
                    {{ 'components.surveys.consensus-degrees.computing' | translate }}
                  } @else {
                    <mat-icon class="mr-1">functions</mat-icon>
                    {{ 'components.surveys.consensus-degrees.compute' | translate }}
                  }
                </button>
                <span class="small text-muted">{{ 'components.surveys.consensus-degrees.compute-hint' | translate }}</span>
              </div>
            }
    }
  </div>

  @if (loading) {
    <div class="loading-container my-4">
      <mat-progress-bar mode="indeterminate" class="custom-progress"></mat-progress-bar>
    </div>
  } @else {
    @if (filteredHistories?.length) {
      <div class="questions-list">
        @for (history of filteredHistories; track history.id; let i = $index) {
          <div class="mb-4">
            <app-question-history-dashboard [questionHistory]="history"></app-question-history-dashboard>
          </div>
        }
      </div>
      <mat-paginator
        class="mt-5 paginator-rounded"
        (page)="onPageChange($event)"
        [length]="totalSurveyQuestionHistories"
        [pageIndex]="currentPageIndex"
        [pageSizeOptions]="[1, 5, 10]"
        [pageSize]="pageSize"
        aria-label="Select page">
      </mat-paginator>
    } @else {
      <div class="empty-state d-flex flex-column align-items-center justify-content-center p-5 text-center">
        <div class="icon-circle mb-3">
          <mat-icon>inbox</mat-icon>
        </div>
        <h5 class="text-dark font-weight-bold">Nessuna cronologia trovata</h5>
        <p class="text-muted">
          {{ "components.surveys.question-history-dashboard.no-question-history" | translate }}
        </p>
      </div>
    }
  }
</div>
